import {AuthState} from './auth/auth.state';
import {DictionaryState} from './dictionary/dictionary.state';
import {UserState} from './user/user.state';
import {AsideState} from './aside/aside.state';
import {BrokerState} from './broker/broker.state';
import {RoleState} from './role/role.state';
import {SearchListState} from './search-list/search-list.state';
import {MakeModelState} from './make-model/make-model.state';
import {PtyState} from './pty/pty.state';
import {VehicleState} from './vehicle/vehicle.state';
import {CalculationState} from './calculation/calculation.state';
import {ImportModalState} from './import-modal/import-modal.state';
import {ClauseState} from './clause/clause.state';
import {RiskState} from './risk/risk.state';
import {AppState} from './app/app.state';
import {SpecialDiscountState} from './special-discount/special-discount.state';
import {GeneralContractState} from './general-contract/general-contract.state';
import {MessageState} from './message/message.state';
import {HogaState} from './hoga/hoga.state';
import {TariffBundleState} from './tariff-bundle/tariff-bundle.state';
import {TariffRateState} from './tariff-rate/tariff-rate.state';
import {PolicyState} from './policy/policy.state';
import {GlmState} from './glm/glm.state';
import {TariffDynamicState} from './tariff-dynamic/tariff-dynamic.state';
import {MatrixState} from './matrix/matrix.state';
import {BusinessDocumentState} from './business-document/business-document.state';
import {AnnexState} from './annex/annex.state';
import {IorState} from './ior/ior.state';
import {ExclusionsState} from './exclusions/exclusions-state.service';
import {WhiteLabelState} from './white-label/white-label.state';
import {RegionalZoneState} from './regional-zone/regional-zone.state';
import {ClientState} from './client/client.state';
import {SearchListConfigState} from './search-list-config/search-list-config.state';
import {GraphState} from './graph/graph.state';
import {CalculationEditState} from './calculation-edit/calculation-edit.state';
import {PolicyEditState} from './policy-edit/policy-edit.state';
import {PolicyAnnexState} from './policy-annex/policy-annex.state';
import {CalculationPolicyEditState} from './calculation-policy-edit/calculation-policy-edit.state';
import {AgroEditState} from './agro-edit/agro-edit.state';
import {AgroEditGenericModalState} from './agro-edit/generic-modals.state';
import {AgroEditPropertyModalState} from './agro-edit/property-modal/agro-edit-property-modal.state';
import {Agro2EditCropsModalState} from './agro-edit/crops-modal/agro-2-edit-crops-modal.state';
import {AgroReportState} from './agro-report/agro-report.state';
import {ClientVerificationState} from './client-verification/client-verification.state';
import {MakeModelAgroState} from './make-model-agro/make-model-agro.state';
import {FleetEditState} from './fleet-edit/fleet-edit.state';
import {PolicyRenewalsState} from './policy-renewals/policy-renewals.state';
import {PolicyGreenCardAddState} from './policy-green-card-add/policy-green-card-add.state';
import {PolicyMassImportState} from './policy-mass-import/policy-mass-import.state';
import {PolicyExcludeState} from './policy/policy-exclude/policy-exclude.state';
import {EnelmedCertificateState} from './enelmed-certificate/enelmed-certificate.state';
import {MakeModelSuggestionState} from './make-model-suggestion/make-model-suggestion.state';
import {GeneralContractVerificationState} from './general-contract-verification/general-contract-verification.state';
import {GeneralContractMassImportState} from './general-contract-mass-import/general-contract-mass-import.state';
import {ProductBusinessDocumentsState} from './product-business-documents/product-business-documents.state';
import {GenericValidationState} from './generic-validation/generic-validation.state';

export const rootState = [
    AnnexState,
    AppState,
    AuthState,
    AsideState,
    BrokerState,
    BusinessDocumentState,
    CalculationState,
    ClauseState,
    DictionaryState,
    SearchListConfigState,
    GeneralContractState,
    GlmState,
    GraphState,
    HogaState,
    ImportModalState,
    IorState,
    MakeModelState,
    MakeModelAgroState,
    MatrixState,
    MessageState,
    PtyState,
    PolicyState,
    ExclusionsState,
    RegionalZoneState,
    RiskState,
    RoleState,
    SearchListState,
    SpecialDiscountState,
    TariffBundleState,
    TariffDynamicState,
    TariffRateState,
    UserState,
    VehicleState,
    WhiteLabelState,
    ClientState,
    CalculationEditState,
    PolicyEditState,
    PolicyAnnexState,
    CalculationPolicyEditState,
    AgroEditState,
    AgroEditGenericModalState,
    AgroEditPropertyModalState,
    Agro2EditCropsModalState,
    AgroReportState,
    ClientVerificationState,
    FleetEditState,
    PolicyRenewalsState,
    PolicyGreenCardAddState,
    PolicyMassImportState,
    PolicyExcludeState,
    EnelmedCertificateState,
    MakeModelSuggestionState,
    GeneralContractVerificationState,
    GeneralContractMassImportState,
    ProductBusinessDocumentsState,
    GenericValidationState,
];
